import { render } from "./EditRequestDialog.vue?vue&type=template&id=dc46356a"
import script from "./EditRequestDialog.vue?vue&type=script&lang=js"
export * from "./EditRequestDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__